import type { FunnelDetailResponse } from '../../lib/api.js';
import { formatNumber } from '../../lib/formatters.js';

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business ファネル詳細ページのヘッダー直下に並ぶ 3 つの KPI カード（全体コンバージョン率 / 最大離脱ステップ / ステップ数）。
 * @graph-connects formatNumber [calls] 数値フォーマット
 */
export function FunnelKpiCards({ data }: { data: FunnelDetailResponse }) {
  const steps = data.steps;
  const firstUsers = steps[0]?.uniqueUsers ?? 0;
  const lastUsers = steps[steps.length - 1]?.uniqueUsers ?? 0;

  let maxDropoffStep = '';
  let maxDropoffRate = 0;
  for (const step of steps) {
    if (step.dropoffRate !== null && step.dropoffRate > maxDropoffRate) {
      maxDropoffRate = step.dropoffRate;
      maxDropoffStep = step.stepName;
    }
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div className="card animate-fade-in-up">
        <p className="text-xs text-[var(--color-text-muted)] mb-1">全体コンバージョン率</p>
        <p className="text-2xl font-bold text-[var(--color-text-primary)]">
          {data.overallConversionRate !== null ? `${String(data.overallConversionRate)}%` : '—'}
        </p>
        <p className="text-xs text-[var(--color-text-muted)] mt-1">
          {formatNumber(firstUsers)} → {formatNumber(lastUsers)}
        </p>
      </div>
      <div className="card animate-fade-in-up">
        <p className="text-xs text-[var(--color-text-muted)] mb-1">最大離脱ステップ</p>
        <p className="text-2xl font-bold text-[var(--color-error)]">{maxDropoffStep || '—'}</p>
        {maxDropoffRate > 0 && (
          <p className="text-xs text-[var(--color-text-muted)] mt-1">
            離脱率 {String(maxDropoffRate)}%
          </p>
        )}
      </div>
      <div className="card animate-fade-in-up">
        <p className="text-xs text-[var(--color-text-muted)] mb-1">ステップ数</p>
        <p className="text-2xl font-bold text-[var(--color-text-primary)]">
          {String(steps.length)}
        </p>
        <p className="text-xs text-[var(--color-text-muted)] mt-1">
          {data.startDate} 〜 {data.endDate}
        </p>
      </div>
    </div>
  );
}
